// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__llibY","footer":"Form_footer__d5GfG"};